import { render, staticRenderFns } from "./CError.vue?vue&type=template&id=fcba0e2e"
import script from "./CError.vue?vue&type=script&setup=true&lang=ts"
export * from "./CError.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports